import React from 'react'
import './LoadingScreen.css'

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-container">
        {/* Samsung One UI Style Spinner */}
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        
        <div className="loading-content">
          <h2 className="loading-title">Geekskul Teacher Portal</h2>
          <p className="loading-subtitle">Loading your dashboard...</p>
        </div>
      </div>
    </div>
  )
}

export default LoadingScreen